import { getWindow } from './getWindow';

export const getIsMobile = () =>
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        getWindow()?.navigator?.userAgent || '',
    );
